import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import { CheckoutMyDetailsStyled } from '../../CheckoutMyDetailsStyled';
import { rem } from 'polished';

export const CheckoutMyDetailsStyledOV = styled(CheckoutMyDetailsStyled)`
    
`;
